import KeyFeaturesComponent from "@/components/keyFeatures";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComponent = () => {
  return <KeyFeaturesComponent {...FEATURES_CONSTANTS} />;
};

export default FeaturesComponent;
